/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	// import { headerVisible } from "../include/module";
	(function () {
	
	  // ------------------------------------------------------------------------
	  // headerVisible
	  // -> SP ヘッダー出現
	  // ------------------------------------------------------------------------
	  // headerVisible();
	
	  // ------------------------------------------------------------------------
	  // headerToggle
	  // -> SP ヘッダー開閉
	  // ------------------------------------------------------------------------
	  (0, _module.headerToggle)();
	
	  // ------------------------------------------------------------------------
	  // newsTile
	  // -> NEWSタイトル 高さ調整
	  // ------------------------------------------------------------------------
	  (0, _module.newsTile)();
	
	  // ------------------------------------------------------------------------
	  // artistTile
	  // -> ARTIST名前 高さ調整
	  // ------------------------------------------------------------------------
	  (0, _module.artistTile)();
	
	  // ------------------------------------------------------------------------
	  // anchorLink
	  // -> リンク
	  // ------------------------------------------------------------------------
	  (0, _module.anchorLink)();
	
	  // ------------------------------------------------------------------------
	  //
	  // -> 汎用変数を定義
	  // ------------------------------------------------------------------------
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	  var breakPoint = 750;
	
	  // ------------------------------------------------------------------------
	  // indexHeader
	  // -> ヘッダーカラーの変更
	  // ------------------------------------------------------------------------
	  var header = document.getElementById('js-Header');
	  window.addEventListener('scroll', function () {
	    var scrollHeight = window.pageYOffset;
	    if (scrollHeight > 180) {
	      header.classList.remove('st-Header-White');
	      header.classList.add('st-Header-Black');
	    } else {
	      header.classList.remove('st-Header-Black');
	      header.classList.add('st-Header-White');
	    }
	  }, false);
	
	  // ------------------------------------------------------------------------
	  // mainSlider
	  // -> 背景画像を設定
	  // ------------------------------------------------------------------------
	  var sliderThumbnail = $('.js-Main_Thumbnail');
	  var sliderThumbnailUrl = [];
	  sliderThumbnail.each(function (index) {
	    sliderThumbnailUrl.push($(sliderThumbnail[index]).data('thumbnail'));
	    $(sliderThumbnail[index]).css('background-image', 'url(' + sliderThumbnailUrl[index] + ')');
	  });
	
	  // ------------------------------------------------------------------------
	  // mainSlider
	  // -> ウィンドウサイズからスライダーの横幅を指定
	  // ------------------------------------------------------------------------
	  var sliderMinHeight = 735;
	  var sliderMaxHeight = 860;
	
	  var sliderMinWidth = 1027;
	  var sliderMaxWidth = 1201;
	
	  var sliderWidth = 0;
	  var sliderWidthRate = 0;
	  var sliderWidthBase = 0;
	
	  var sliderSetWidth = function sliderSetWidth(currentHeight, resultWidth) {
	    var sliderHeightBase = currentHeight - sliderMinHeight;
	    var sliderHeightDifference = sliderMaxHeight - sliderMinHeight;
	    var sliderWidthDifference = sliderMaxWidth - sliderMinWidth;
	    if (currentHeight < sliderMinHeight) {
	      resultWidth = sliderMinWidth;
	    } else if (currentHeight > sliderMaxHeight) {
	      resultWidth = sliderMaxWidth;
	    } else {
	      sliderWidthRate = sliderHeightBase / sliderHeightDifference;
	      sliderWidthBase = sliderWidthDifference * sliderWidthRate;
	      resultWidth = sliderMinWidth + sliderWidthBase;
	    }
	    return resultWidth;
	  };
	
	  var sliderSet = function sliderSet(currentWidth, resultWidth) {
	    if (currentWidth > breakPoint) {
	      var sliderObject = $('#js-Main_Slider').bxSlider({
	        auto: true,
	        speed: 800,
	        pause: 8000,
	        responsive: true,
	        touchEnabled: false,
	        slideWidth: resultWidth,
	        moveSlides: 1,
	        controls: true,
	        onSliderLoad: function onSliderLoad(index) {
	          $($('.idx-Main_Visual_List_Item')[index + 1]).find('.Item_Information').addClass('Item_Information-Animate');
	          $($('.idx-Main_Visual_List_Item')[index + 1]).find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
	          $($('.idx-Main_Visual_List_Item')[index + 1]).find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
	          setTimeout(function () {
	            sliderObject.startAuto();
	          }, 1000);
	        },
	        onSlideBefore: function onSlideBefore($slideElement, oldIndex, newIndex) {
	          $('.idx-Main_Visual_List_Item').find('.Item_Information').removeClass('Item_Information-Animate');
	          $('.idx-Main_Visual_List_Item').find('.Item_Information_Curtain').removeClass('Item_Information_Curtain-Animate');
	          $('.idx-Main_Visual_List_Item').find('.Item_Information_Base').removeClass('Item_Information_Base-Animate');
	        },
	        onSlideAfter: function onSlideAfter($slideElement, oldIndex, newIndex) {
	          $slideElement.find('.Item_Information').addClass('Item_Information-Animate');
	          $slideElement.find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
	          $slideElement.find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
	          sliderObject.startAuto();
	        }
	      });
	    } else {
	      var _sliderObject = $('#js-Main_Slider').bxSlider({
	        auto: true,
	        infiniteLoop: true,
	        responsive: true,
	        speed: 800,
	        pager: true,
	        controls: false,
	        moveSlides: 1,
	        pause: 8000,
	        oneToOneTouch: true,
	        onSliderLoad: function onSliderLoad(index) {
	          $($('.idx-Main_Visual_List_Item')[index + 1]).find('.Item_Information').addClass('Item_Information-Animate');
	          $($('.idx-Main_Visual_List_Item')[index + 1]).find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
	          $($('.idx-Main_Visual_List_Item')[index + 1]).find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
	          setTimeout(function () {
	            _sliderObject.startAuto();
	          }, 1000);
	        },
	        onSlideBefore: function onSlideBefore($slideElement, oldIndex, newIndex) {
	          $('.idx-Main_Visual_List_Item').find('.Item_Information').removeClass('Item_Information-Animate');
	          $('.idx-Main_Visual_List_Item').find('.Item_Information_Curtain').removeClass('Item_Information_Curtain-Animate');
	          $('.idx-Main_Visual_List_Item').find('.Item_Information_Base').removeClass('Item_Information_Base-Animate');
	        },
	        onSlideAfter: function onSlideAfter($slideElement, oldIndex, newIndex) {
	          $slideElement.find('.Item_Information').addClass('Item_Information-Animate');
	          $slideElement.find('.Item_Information_Curtain').addClass('Item_Information_Curtain-Animate');
	          $slideElement.find('.Item_Information_Base').addClass('Item_Information_Base-Animate');
	          _sliderObject.startAuto();
	        }
	      });
	    }
	  };
	
	  sliderSet(windowWidth, sliderSetWidth(windowHeight, sliderWidth));
	
	  window.addEventListener('resize', function () {
	    var resizeWidth = window.innerWidth;
	    var resizeHeight = window.innerHeight;
	    var resizeSliderWidth = 0;
	    sliderSet(resizeWidth, sliderSetWidth(resizeHeight, resizeSliderWidth));
	  }, false);
	
	  // ------------------------------------------------------------------------
	  // artistImage
	  // -> 背景画像を切り替え
	  // ------------------------------------------------------------------------
	  var artistImage = $('#js-Artist_Image');
	  var artistImageUrl = [];
	  var artistImageItem = $('.js-Artist_Image_Item');
	  var artistSwitchTime = 6000;
	  artistImageItem.each(function (index) {
	    artistImageUrl.push($(artistImageItem[index]).data('image'));
	    $(artistImageItem[index]).css('background-image', 'url(' + artistImageUrl[index] + ')');
	  });
	
	  $('#js-Artist_Image li:gt(0)').hide();
	
	  var artistImageAnime = function () {
	    var i = 0;
	    var t = artistSwitchTime / 1000 * 60;
	    return function () {
	      if (i % t === 0) {
	        $('#js-Artist_Image li:first-child').fadeOut(2000).next('li').fadeIn(2000).end().appendTo('#js-Artist_Image');
	      }
	      i++;
	    };
	  }();
	
	  (function artistImageAnimeLoop() {
	    artistImageAnime();
	    window.requestAnimationFrame(artistImageAnimeLoop);
	  })();
	
	  // (function)
	
	  // $(artistImageItem[0]).fadeIn(artistSwitchTime * 0.2).addClass('idx-Artist_Image_List_Item-Animate');
	  //
	  // setInterval(function(){
	  //   let artistImageItemActive = $('.idx-Artist_Image_List_Item-Animate');
	  //   let artistImageItemNext   = artistImageItemActive.next('li').length?artistImageItemActive.next('li'):$(artistImageItem[0]);
	  //   $(artistImageItemNext).fadeIn(artistSwitchTime * 0.2).addClass('idx-Artist_Image_List_Item-Animate');
	  //   $(artistImageItemActive).fadeOut(artistSwitchTime * 0.4).removeClass('idx-Artist_Image_List_Item-Animate');
	  // }, artistSwitchTime);
	
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 750;
	
	var windowWidth = window.innerWidth;
	
	var headerBar = document.getElementById('js-Header--Bar');
	var headerMenu = document.getElementById('js-Header--Menu');
	var headerButtonOpen = document.getElementById('js-Header_Button_Open');
	var headerButtonClose = document.getElementById('js-Header_Button_Close');
	
	// ------------------------------------------------------------------------
	// headerVisible
	// -> SP ヘッダー出現
	// ------------------------------------------------------------------------
	// const headerVisible = () => {
	// if(windowWidth < breakPoint){
	//   window.addEventListener('scroll', () => {
	//     let scrollGoal   = windowWidth * 0.8;
	//     let scrollVolume = window.pageYOffset;
	//     if(scrollVolume > scrollGoal){
	//       headerBar.classList.remove('st-Header--Bar-Hidden');
	//     } else {
	//       headerBar.classList.add('st-Header--Bar-Hidden');
	//     }
	//   }, false);
	// }
	// }
	
	
	// ------------------------------------------------------------------------
	// headerToggle
	// -> SP ヘッダー開閉
	// ------------------------------------------------------------------------
	var headerToggle = function headerToggle() {
	  var headerStatus = false;
	  window.addEventListener('load', function () {
	    headerButtonOpen.addEventListener('click', function () {
	      if (!headerStatus) {
	        headerBar.classList.add('st-Header--Bar-Hidden');
	        headerMenu.classList.remove('st-Header--Menu-Hidden');
	        headerStatus = true;
	      }
	    }, false);
	    headerButtonClose.addEventListener('click', function () {
	      if (headerStatus) {
	        headerBar.classList.remove('st-Header--Bar-Hidden');
	        headerMenu.classList.add('st-Header--Menu-Hidden');
	        headerStatus = false;
	      }
	    }, false);
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// newsTile
	// -> NEWSタイトル 高さ調整
	// ------------------------------------------------------------------------
	var newsTile = function newsTile() {
	  window.addEventListener('load', function () {
	    if (windowWidth > breakPoint) {
	      $('.js-News_Title').tile(3);
	    } else {
	      $('.js-News_Title').tile();
	    }
	  }, false);
	  window.addEventListener('resize', function () {
	    var resizeWidth = window.innerWidth;
	    if (resizeWidth > breakPoint) {
	      $('.js-News_Title').tile(3);
	    } else {
	      $('.js-News_Title').tile();
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// artistTile
	// -> ARTIST名前 高さ調整
	// ------------------------------------------------------------------------
	var artistTile = function artistTile() {
	  window.addEventListener('load', function () {
	    $('.js-Artist').tile();
	    $('.js-Artist_Name').tile();
	  }, false);
	  window.addEventListener('resize', function () {
	    $('.js-Artist').tile();
	    $('.js-Artist_Name').tile();
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// discographyTile
	// -> DISCOGRAPHY CDタイトル 高さ調整
	// ------------------------------------------------------------------------
	var discographyTile = function discographyTile(targetClass) {
	  window.addEventListener('load', function () {
	    if (windowWidth > breakPoint) {
	      $(targetClass).tile(4);
	    } else {
	      $(targetClass).tile(2);
	    }
	  }, false);
	  window.addEventListener('resize', function () {
	    var resizeWidth = window.innerWidth;
	    if (resizeWidth > breakPoint) {
	      $(targetClass).tile(4);
	    } else {
	      $(targetClass).tile(2);
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// -> リンク
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkHeight = 0;
	    if (windowWidth < breakPoint) {
	      linkHeight = windowWidth * 0.21;
	    }
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top - linkHeight;
	    $("html, body").animate({ scrollTop: linkPosition }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// export
	// ------------------------------------------------------------------------
	exports.headerToggle = headerToggle;
	exports.newsTile = newsTile;
	exports.artistTile = artistTile;
	exports.discographyTile = discographyTile;
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js